/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TranslatorProviderType = {
    AzureTranslator: 'AzureTranslator',
    LlmTranslator: 'LlmTranslator'
} as const;
export type TranslatorProviderType = typeof TranslatorProviderType[keyof typeof TranslatorProviderType];


export function instanceOfTranslatorProviderType(value: any): boolean {
    for (const key in TranslatorProviderType) {
        if (Object.prototype.hasOwnProperty.call(TranslatorProviderType, key)) {
            if (TranslatorProviderType[key as keyof typeof TranslatorProviderType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TranslatorProviderTypeFromJSON(json: any): TranslatorProviderType {
    return TranslatorProviderTypeFromJSONTyped(json, false);
}

export function TranslatorProviderTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslatorProviderType {
    return json as TranslatorProviderType;
}

export function TranslatorProviderTypeToJSON(value?: TranslatorProviderType | null): any {
    return value as any;
}

export function TranslatorProviderTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TranslatorProviderType {
    return value as TranslatorProviderType;
}

